export const colors = {
  black: "#383838",
  white: "#FFF",
  plum: "#2D1996"
}
